import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';

import usflag from '../assets/images/language/us.svg';
import seflag from '../assets/images/language/es.png';
import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

function Languages() {
  const [t, i18n]= useTranslation('global');
  const dispatch = useDispatch();
  const { isAuthenticated, locale } = useSelector((state) => state.auth);
  const options = [
    {
      value: "en",
      label: (<img src={usflag} width="20" alt="" />)
    }, 
    {
      value: "es",
      label: (<img src={seflag} width="20" alt="" />)
    },
       
  ];
  const [lang, setLang] = useState(i18n.language);


  function handleLanguageChange(e) {
    const { name, value } = e.target;
 
    i18n.changeLanguage(value)
    setLang(value);
   
  }
    return (
      <div>
              <TextField sx={{ minWidth: 50, "& fieldset": { border: 'none' } }} select
                  name="language"
                  id="demo-select-small"
                  defaultValue={i18n.language}
                  onChange={handleLanguageChange}
                >
                  <MenuItem value={'en'}> 
                  {options[0].label}&nbsp;{options[0].value}</MenuItem>
                  <MenuItem value={'es'}> 
                  {options[1].label}&nbsp;{options[1].value}</MenuItem>
              </TextField>
    </div>
      );
}

export default Languages